var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H0V0Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18H25.7333C27.2268 18 27.9735 18 28.544 18.2906C29.0457 18.5463 29.4537 18.9543 29.7094 19.456C30 20.0265 30 20.7732 30 22.2667V27M20.1333 30H25.5333C26.2801 30 26.6534 30 26.9387 29.8547C27.1895 29.7268 27.3935 29.5229 27.5213 29.272C27.6667 28.9868 27.6667 28.6134 27.6667 27.8667V22.4667C27.6667 21.7199 27.6667 21.3466 27.5213 21.0613C27.3935 20.8105 27.1895 20.6065 26.9387 20.4787C26.6534 20.3333 26.2801 20.3333 25.5333 20.3333H20.1333C19.3866 20.3333 19.0132 20.3333 18.728 20.4787C18.4771 20.6065 18.2732 20.8105 18.1453 21.0613C18 21.3466 18 21.7199 18 22.4667V27.8667C18 28.6134 18 28.9868 18.1453 29.272C18.2732 29.5229 18.4771 29.7268 18.728 29.8547C19.0132 30 19.3866 30 20.1333 30Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copyButton.0d42b7fd91abbf81df28a37cc95e5bfb.svg";
export { ForwardRef as ReactComponent };